import ScrollMagic from 'scrollmagic';
import 'ScrollMagicAddIndicators';

export default {
	init() {

		function ImageMoveOnScroll( container ) {

			var controller = new ScrollMagic.Controller();
			var image = container.querySelector('.fullscreenImage__image');
			var containerHeight = container.offsetHeight;

			var transform;

			new ScrollMagic.Scene({triggerElement: container, duration: '68%', triggerHook: 0 })
				// trigger animation by adding a css class
				// .addIndicators({name: "- fullscreenImage "}) // add indicators (requires plugin)
				.addTo(controller)
				.offset(1)
				.on("progress", function (e) {

					if( window.innerWidth > 800 ) {

						transform = containerHeight * e.progress.toFixed(2) * 0.3;
						image.style.transform = 'translateY('+transform+'px)';

					}

				});

		} 

		var container = document.querySelectorAll('.fullscreenImage.imageAnimation');

		if( container.length > 0 ) {

			container.forEach( function( box, index ){

				ImageMoveOnScroll( box );

			});

		}


		// --------------


		function ScrolToNextSection( container ) {

			var button = container.querySelector('button');
			

			var nextSection;
			var nextSectionCoordinate;
			var nextSectionStyle;
			var topDistance;
			function getTopDistance() {

				topDistance = 0;

				nextSection = document.querySelectorAll('section')[1];

				nextSectionStyle = parseInt( getComputedStyle(nextSection).marginTop.replace('px','') );

				topDistance = nextSection.getBoundingClientRect().top + window.pageYOffset - nextSectionStyle;

				if( window.innerWidth < 1160 ) {

					topDistance -= document.querySelector('header').offsetHeight;

				} 				

			}

			button.addEventListener('click', function(){

				getTopDistance();

				window.scrollTo({
				    top: topDistance,
				    behavior: 'smooth'
				});

			});

			window.addEventListener('resize', function() {

				getTopDistance();

			});


			// -- ScrollMagic -- // 

				var sectionParent = container.closest('section');

				var controller = new ScrollMagic.Controller();

				new ScrollMagic.Scene({triggerElement: sectionParent , triggerHook: 0 })
					// trigger animation by adding a css class
					.setClassToggle(container, "hide")
					// .addIndicators({name: "- ScrolToNextSection "}) // add indicators (requires plugin)
					.addTo(controller)
					.offset( sectionParent.offsetHeight/2 );

			// -- END -- // 

		}

		var container2 = document.querySelector('.fullscreenImage__findOut');

		if( container2 ) {

			ScrolToNextSection( container2 );

		}
    
	},
	finalize() {
    // JavaScript to be fired on the home page, after the init JS
	},
};
